import { ApiConfig } from "../../Config/ApiConfig";
import { createFormDataAction, createGetDataAction, createPostDataAction } from "./CommonAction";
import { SALONLIST , SALONSTATUS , SALONDETAILS , SALONAPPROVEDSTATUS ,DELETEBUSINESS ,SALONUPFDATE , SALONDELETE, SALONSUBSCRIPTIONMANAGE } from "../../Constants/SalonConstants";



export const SalonGetAction = (payload:any) => createPostDataAction(SALONLIST, ApiConfig?.SalonGetList,payload,false );
export const SalonStatusAction = (payload:any) => createPostDataAction(SALONSTATUS, ApiConfig?.SalonStatus,payload,true );
export const SalonDetailsAction = (payload:any) => createPostDataAction(SALONDETAILS, ApiConfig?.SalonDetail,payload,false );
export const SalonApprovedStatusAction = (payload:any) => createPostDataAction(SALONSTATUS, ApiConfig?.SalonApprovedStatus,payload,true );
export const SalondeletebusinessAction = (payload:any) => createPostDataAction(DELETEBUSINESS, ApiConfig?.SalonBusinessdelete,payload,true );
export const SalonUpdateAction = (payload:any) => createFormDataAction(SALONUPFDATE, ApiConfig?.SalonUpdate,payload,true );
export const SalonDeleteAction =(payload:any)=>createPostDataAction(SALONDELETE , ApiConfig?.SalonDelete , payload , true)

export const SalonSubscriptionManageAction = (payload: any) => {
  let apiEndpoint = ApiConfig.SalonSubscriptionActivate;
  if (payload?._action === "suspend") {
    apiEndpoint = ApiConfig.SalonSubscriptionSuspend;
  } else if (payload?._action === "assign-plan") {
    apiEndpoint = ApiConfig.SalonSubscriptionAssignPlan;
  }
  return createPostDataAction(
    SALONSUBSCRIPTIONMANAGE,
    apiEndpoint,
    { salon_id: payload.salon_id, plan_id: payload.plan_id },
    true,
  );
};